import { render, staticRenderFns } from "./popup-do-huamingce.vue?vue&type=template&id=9f271aca&scoped=true"
import script from "./popup-do-huamingce.vue?vue&type=script&lang=js"
export * from "./popup-do-huamingce.vue?vue&type=script&lang=js"
import style0 from "./popup-do-huamingce.vue?vue&type=style&index=0&id=9f271aca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f271aca",
  null
  
)

export default component.exports